import React from 'react'

import { ReactComponent as ArrowIcon } from '@/assets/svgs/arrow_icon.svg'
import { theme } from '@/theme'

import type { CustomButtonProps } from './types'

export default function MonthButton({
  type,
  onClick,
  style,
}: CustomButtonProps) {
  const handleClick = (e) => {
    e.preventDefault()
    onClick()
  }
  return (
    <button
      aria-label={`${type} Month`}
      className={`react-datepicker__navigation
                react-datepicker__navigation--month
                react-datepicker__navigation--${type}`}
      onClick={handleClick}
      style={style}
      type="button"
    >
      <span
        className={`react-datepicker__navigation-icon react-datepicker__navigation-icon--${type}`}
      >
        <ArrowIcon color={theme.colors.slateGray} />
      </span>
    </button>
  )
}
